import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { Log } from "ng2-logger";

@Component({
    selector: 'app-dropdown-multiple',
    templateUrl: './dropdown-multiple.component.html',
    styleUrls: ['./dropdown-multiple.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DropdownMultipleComponent,
            multi: true
        }
    ]
})
export class DropdownMultipleComponent implements OnInit, ControlValueAccessor {
    @ViewChild('dropdownContainer', {static: false}) dropdownContainer: ElementRef;

    @Input() labelAlign: 'top' | 'left' | 'floating' = 'top';
    @Input() label = '';
    @Input() displayField = 'name';
    @Input() valueField = 'id';
    @Input() emptyText = 'No empty text provided';
    @Input() isDisabled = false;
    @Input() items = [];
    @Input() formControl: UntypedFormControl;
    @Input() showErrors = false;
    @Input() hasHeader = false;
    @Input() placeholder = '';
    @HostBinding('class.m2') @Input() m2 = false;
    @Output() selection = new EventEmitter<any[]>();

    selectedItems: any[] = [];

    private onChangeCallback: (value: any) => void = () => {
    };
    private onTouchedCallback: () => void = () => {
    };

    constructor() {
    }

    ngOnInit(): void {
    }

    // Set the value from the form control
    writeValue(value: any[]): void {
        this.selectedItems = value || [];
    }

    // Register the change callback
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    // Register the touch callback
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    // Handle item selection
    onItemSelect(value: any): void {
        this.selectedItems = value.value;
        this.onChangeCallback(this.selectedItems); // Notify form control of value change
        this.selection.emit(this.selectedItems); // Emit selected items
    }

    // Mark as touched
    markAsTouched(): void {
        this.onTouchedCallback();
    }

    // Prevent click event propagation
    preventPropagation(event: Event): void {
        event.stopPropagation();
    }

    // Getter for form control errors
    get hasError(): boolean {
        return this.formControl && this.formControl.errors && this.showErrors;
    }

    get leftLabel(): boolean {
        return this.label && this.labelAlign === 'left';
    }

    get topLabel(): boolean {
        return this.label && this.labelAlign === 'top';
    }

    get floatLabel(): boolean {
        return this.label && this.labelAlign === 'floating';
    }
}